import React from 'react'
import Title from '../Shared/Title/Title'
import { useLocalPath } from '../hooks/useLocalPath'
import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import * as styles from './blogCards.module.scss'

const RecipeCard = ({ gridItems }) => {
    const { otherPages, title, backgroundColor } = gridItems
    return (
        <div className='container' style={{ background: backgroundColor }}>
            <div className={`container-lg ${styles.wrapper}`}>
                <h2 className={styles.title}><Title title = {title} /> </h2>
                <div className={styles.cardContainer} >
                    {
                        otherPages && otherPages.map((card: any, id: number) => {
                            const { slug, thumbnailImage, thumbnailTitle, blogType } = card
                            return (
                                <Link to={useLocalPath(slug)} key={id} className={styles.cardWrapper}>
                                    <div className={styles.card}>
                                        <div className={styles.cardImage}>
                                            <GatsbyImage
                                                image={thumbnailImage.gatsbyImageData}
                                                alt={`${thumbnailImage.title} image`}
                                                loading="lazy"
                                            />
                                        </div>
                                        <div className={styles.cardInfo}>
                                            <p className={styles.type}>{blogType}</p>
                                            <div className={styles.cardTitle}> {thumbnailTitle} </div>
                                        </div>
                                    </div>
                                </Link>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default RecipeCard